var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFF6E5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.9543 0 0 8.9543 0 20C0 20.2679 0.00526809 20.5346 0.0157063 20.8C0.435613 10.1251 9.22222 1.59993 20 1.59993C30.7778 1.59993 39.5644 10.1251 39.9843 20.8C39.9947 20.5346 40 20.2679 40 20C40 8.9543 31.0457 0 20 0Z",
    fill: "#CACACA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 19.7321 39.9947 19.4654 39.9843 19.2C39.5644 29.8749 30.7778 38.4001 20 38.4001C9.22223 38.4001 0.435616 29.8749 0.0157107 19.2C0.00527371 19.4654 5.58657e-06 19.7321 5.56315e-06 20C4.59751e-06 31.0457 8.95431 40 20 40Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8313 10.7475V15.3189H12.2301C12.0701 15.3196 11.9116 15.2882 11.764 15.2265C11.6163 15.1649 11.4825 15.0743 11.3705 14.9601C11.2584 14.8459 11.1704 14.7104 11.1115 14.5616C11.0527 14.4128 11.0243 14.2537 11.028 14.0938V10.8206C11.0258 10.7963 11.0258 10.7718 11.028 10.7475H19.8313Z",
    fill: "#FDCD08"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6347 10.7475H11.0327C11.0446 10.4382 11.1761 10.1457 11.3995 9.93161C11.623 9.71752 11.9208 9.59864 12.2303 9.60005H27.46C27.7659 9.6034 28.0586 9.72452 28.2774 9.93824C28.4962 10.1519 28.6242 10.4418 28.6347 10.7475Z",
    fill: "#F8EC30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6389 10.8206V14.0938C28.642 14.2514 28.6138 14.4082 28.5561 14.5549C28.4984 14.7017 28.4123 14.8356 28.3028 14.949C28.1932 15.0624 28.0623 15.1531 27.9176 15.2158C27.773 15.2785 27.6173 15.312 27.4597 15.3143H19.8311V10.7429H28.6344C28.6383 10.7686 28.6398 10.7946 28.6389 10.8206Z",
    fill: "#F58A1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5416 10.4776H12.3394V14.4365H13.5416V10.4776Z",
    fill: "#FCEE3B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.841 10.4776H14.6387V14.4365H15.841V10.4776Z",
    fill: "#FCEE3B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1354 10.4776H16.9331V14.4365H18.1354V10.4776Z",
    fill: "#FCEE3B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4345 10.4776H19.2322V14.4365H20.4345V10.4776Z",
    fill: "#FCEE3B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7335 10.4776H21.5312V14.4365H22.7335V10.4776Z",
    fill: "#FCEE3B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0326 10.4776H23.8303V14.4365H25.0326V10.4776Z",
    fill: "#FCEE3B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3317 10.4776H26.1294V14.4365H27.3317V10.4776Z",
    fill: "#FCEE3B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8313 16.4571V21.0286H12.2302C12.0721 21.0268 11.916 20.9937 11.7708 20.9313C11.6256 20.8689 11.4941 20.7783 11.3841 20.6648C11.274 20.5514 11.1875 20.4172 11.1296 20.2702C11.0716 20.1231 11.0433 19.966 11.0463 19.808V16.5394C11.0441 16.5136 11.0441 16.4876 11.0463 16.4617L19.8313 16.4571Z",
    fill: "#FDCD08"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6347 16.4571H11.0327C11.0457 16.1486 11.1778 15.8573 11.4011 15.6441C11.6244 15.431 11.9216 15.3128 12.2303 15.3142H27.46C27.7651 15.3175 28.0572 15.438 28.2759 15.6508C28.4945 15.8635 28.623 16.1522 28.6347 16.4571Z",
    fill: "#F8EC30"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6389 16.5394V19.808C28.642 19.9657 28.6138 20.1224 28.5561 20.2691C28.4984 20.4159 28.4123 20.5498 28.3028 20.6632C28.1932 20.7767 28.0623 20.8673 27.9176 20.93C27.773 20.9927 27.6173 21.0262 27.4597 21.0286H19.8311V16.4571H28.6344C28.6383 16.4844 28.6399 16.5119 28.6389 16.5394Z",
    fill: "#F58A1F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5416 16.1918H12.3394V20.1507H13.5416V16.1918Z",
    fill: "#FCEE3B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.841 16.1918H14.6387V20.1507H15.841V16.1918Z",
    fill: "#FCEE3B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1354 16.1918H16.9331V20.1507H18.1354V16.1918Z",
    fill: "#FCEE3B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4345 16.1918H19.2322V20.1507H20.4345V16.1918Z",
    fill: "#FCEE3B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7335 16.1918H21.5312V20.1507H22.7335V16.1918Z",
    fill: "#FCEE3B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0326 16.1918H23.8303V20.1507H25.0326V16.1918Z",
    fill: "#FCEE3B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3317 16.1918H26.1294V20.1507H27.3317V16.1918Z",
    fill: "#FCEE3B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3765 22.1713V26.7428H9.75244C9.59457 26.7398 9.43883 26.7057 9.29412 26.6425C9.14941 26.5794 9.01856 26.4883 8.90905 26.3745C8.79954 26.2607 8.71352 26.1265 8.65589 25.9795C8.59826 25.8324 8.57016 25.6755 8.57319 25.5176V22.249C8.57098 22.2232 8.57098 22.1972 8.57319 22.1713H17.3765Z",
    fill: "#FDCD08"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1798 22.1716H8.57324C8.585 21.8659 8.71413 21.5766 8.93377 21.3637C9.15342 21.1508 9.44666 21.0309 9.7525 21.0287H25.028C25.3291 21.0378 25.6154 21.1608 25.8293 21.373C26.0431 21.5851 26.1684 21.8706 26.1798 22.1716Z",
    fill: "#F8EC30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1843 22.249V25.5176C26.1905 25.8326 26.0729 26.1375 25.8566 26.3667C25.6403 26.5958 25.3428 26.7308 25.0279 26.7428H17.3765V22.1713H26.1798C26.1835 22.1971 26.185 22.2231 26.1843 22.249Z",
    fill: "#F58A1F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0829 21.9063H9.88062V25.8652H11.0829V21.9063Z",
    fill: "#FCEE3B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3817 21.9063H12.1794V25.8652H13.3817V21.9063Z",
    fill: "#FCEE3B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6808 21.9063H14.4785V25.8652H15.6808V21.9063Z",
    fill: "#FCEE3B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9799 21.9063H16.7776V25.8652H17.9799V21.9063Z",
    fill: "#FCEE3B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2792 21.9063H19.0769V25.8652H20.2792V21.9063Z",
    fill: "#FCEE3B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5783 21.9063H21.376V25.8652H22.5783V21.9063Z",
    fill: "#FCEE3B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8773 21.9063H23.675V25.8652H24.8773V21.9063Z",
    fill: "#FCEE3B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6192 27.8858V32.4573H14.9951C14.6771 32.4513 14.3744 32.3194 14.1534 32.0906C13.9323 31.8619 13.811 31.5548 13.8159 31.2367V27.9635C13.8137 27.9377 13.8137 27.9117 13.8159 27.8858H22.6192Z",
    fill: "#FDCD08"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4272 27.8858H13.8206C13.8312 27.5805 13.9593 27.2912 14.1782 27.0782C14.3971 26.8652 14.6899 26.7451 14.9952 26.7429H30.2479C30.5537 26.745 30.847 26.865 31.0666 27.0779C31.2863 27.2908 31.4154 27.5801 31.4272 27.8858Z",
    fill: "#F8EC30"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M31.427 27.9635V31.2367C31.4319 31.5548 31.3105 31.8619 31.0895 32.0906C30.8685 32.3194 30.5658 32.4513 30.2477 32.4573H22.6191V27.8858H31.427C31.4292 27.9117 31.4292 27.9377 31.427 27.9635Z",
    fill: "#F58A1F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3253 27.6205H15.123V31.5794H16.3253V27.6205Z",
    fill: "#FCEE3B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6244 27.6205H17.4221V31.5794H18.6244V27.6205Z",
    fill: "#FCEE3B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9235 27.6205H19.7212V31.5794H20.9235V27.6205Z",
    fill: "#FCEE3B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2228 27.6205H22.0205V31.5794H23.2228V27.6205Z",
    fill: "#FCEE3B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5219 27.6205H24.3196V31.5794H25.5219V27.6205Z",
    fill: "#FCEE3B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8209 27.6205H26.6187V31.5794H27.8209V27.6205Z",
    fill: "#FCEE3B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30.12 27.6205H28.9177V31.5794H30.12V27.6205Z",
    fill: "#FCEE3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.16a58f9495c140d39206d8a87c70e44e.svg";
export { ForwardRef as ReactComponent };